import React, { type FocusEvent, useState } from 'react';

import * as Styled from './Input.styled';
import { InputProps } from './Input.typed';

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (props: InputProps, ref) => {
    const {
      leading,
      trailing,
      hasError,
      disabled,
      onFocus,
      onBlur,
      height,
      padding,
      ...rest
    } = props;
    const [isFocused, setIsFocused] = useState(false);

    const handleOnFocus = (event: FocusEvent<HTMLInputElement>) => {
      setIsFocused(true);
      !!onFocus && onFocus(event);
    };
    const handleOnBlur = (event: FocusEvent<HTMLInputElement>) => {
      setIsFocused(false);
      !!onBlur && onBlur(event);
    };
    return (
      <Styled.Container
        hasError={hasError}
        disabled={disabled}
        focused={isFocused}
        height={height}
        padding={padding}
      >
        {!!leading && <Styled.Leading>{leading}</Styled.Leading>}
        <Styled.Input
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          disabled={disabled}
          ref={ref}
          {...rest}
        />
        {!!trailing && <Styled.Trailing>{trailing}</Styled.Trailing>}
      </Styled.Container>
    );
  },
);

export default Input;
